import React, { useContext, useEffect, useState } from 'react';
import { AssignmentInd, Info } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppContext } from '../../AppContext';
import { Actions } from '../../enums/ActionEnums';
import { AuthRoutes, RouteNames } from '../../enums/RouteEnums';
import { IProduct, useProductQuery } from '../../generated/graphql';
import CustomAppBar from '../Common/Layout/CustomAppBar';
import OverviewToolbar from '../Common/Layout/OverviewToolbar';
import TabPanel from '../Common/Layout/TabPanel';
import Loader from '../Common/Loader';
import ProductDetailsTabs from './Details/ProductDetailsTabs';

const ProductInfoWrapper: React.FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { dispatch, state } = useContext(AppContext);

  const [product, setProduct] = useState<IProduct | null>(null);
  const [tabValue, setTabValue] = useState(0);

  const locationElements = location.pathname.split('/').filter((e) => e);

  const { data } = useProductQuery({
    variables: {
      id: parseInt(locationElements[locationElements.length - 1])
    },
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data && data.result) {
      dispatch({
        type: Actions.SetSelectedProduct,
        payload: { name: data.result.name }
      });
      setProduct(data.result as IProduct);
    }
  }, [data]);

  const handleToProductsOverview = () => {
    dispatch({ type: Actions.ResetSelectedProduct });
    navigate(AuthRoutes.Products);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <OverviewToolbar handleToOverview={handleToProductsOverview} navName={RouteNames.Products}>
        <Box className="centralize">
          <AssignmentInd sx={{ marginRight: '7px' }} />
          {state.selectedProduct || product?.name}
        </Box>
      </OverviewToolbar>
      <Box>
        <CustomAppBar
          value={tabValue}
          handleChange={(_, newValue) => setTabValue(newValue)}
          tabProps={[{ id: 'product-details', title: 'Details', icon: Info }]}
        />
        <Box>
          <TabPanel value={tabValue} index={0}>
            {product ? <ProductDetailsTabs product={product} /> : <Loader loading={true} />}
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
};

export default ProductInfoWrapper;
